(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name createPairing.controller:CreatePairingCtrl
     *
     * @description
     *
     */
    angular
        .module('createPairing')


      .directive('resizer', function($document) {

        return function($scope, $element, $attrs) {

          $element.on('mousedown', function(event) {
            event.preventDefault();

            $document.on('mousemove', mousemove);
            $document.on('mouseup', mouseup);
          });

          function mousemove(event) {

            if ($attrs.resizer == 'vertical') {
              // Handle vertical resizer
              var x = event.pageX;

              if ($attrs.resizerMax && x > $attrs.resizerMax) {
                x = parseInt($attrs.resizerMax);
              }

              $element.css({
                left: x + 'px'
              });

              $($attrs.resizerLeft).css({
                width: x + 'px'
              });
              $($attrs.resizerRight).css({
                left: (x + parseInt($attrs.resizerWidth)) + 'px'
              });

            } else {
              // Handle horizontal resizer
              var y = window.innerHeight - event.pageY;

              if(y > 700) {
                y = 700;
              }else if (y < 65){
                y = 65;
              }

              $element.css({
                bottom: y + 'px'
              });

              $($attrs.resizerTop).css({
                bottom: (y + parseInt($attrs.resizerHeight)) + 'px'
              });
              $($attrs.resizerBottom).css({
                height: y + 'px'
              });

            }
          }

          function mouseup() {
            $document.unbind('mousemove', mousemove);
            $document.unbind('mouseup', mouseup);
          }
        };
      })




        .controller('CreatePairingCtrl', CreatePairingCtrl);

    function CreatePairingCtrl(CommonMasterData, CreatePairing, EventManagerService, ToolBarService,PopupManager,TabService,
                               $timeout, MessageService, CommonLogicService, ContextMenuService, $stateParams, StorageServices,ApplicationParametersService,ConfigDistributionService, $scope) {

      EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);


        var vm = this,
            viewModes = {
                day: 'D',
                week: 'W',
                month: 'M'
            },
            viewButtonConfigs={
                CREATE_PAIRING_DAY:{
                    selected:false,
                    disable:true,
                    display:true
                },
                CREATE_PAIRING_WEEK:{
                    selected:false,
                    disable:true,
                    display:true
                },
                CREATE_PAIRING_MONTH:{
                    selected:false,
                    disable:true,
                    display:true
                }
            };
        vm.view = "CREATE_PAIRING_FLIGHTS";
        var searchPanels = CreatePairing.seachActions;

        var defaultBase  = { appParameterDesc: "Default crew base"};
        var selectedBlockForContextMenu = null;
        vm.model = {
          languages:[],
        	trainingOnlyPattern : false,
            mode:$stateParams.mode,
            pairingId:$stateParams.pid,
            fdpValidFlag:false,
            pairingSaveValidFlag:false,
            isCrewReqValid: false,
            isMinimumRestValid : false,
            minimumRestValidationMsg : "",
            airportList: [],
            numberOfDays : [],
            crewBaseList: [],
            airCraftTypes:[],
            trainingCategoryList:[],
            trainingLocationsList:[],
            searchWithinList: [],
            relatedPatterns: [],
            options: [],
            viewMode: 'W',
            searchParam: null,
            flights: [],
            flightTotalRecords:0,
            trainings: [],
            trainingPrograms: [],
            trainingProgramDetails: [],
            isRestRequired:false,
            event: {},
            events: [],
            viewUpdate: false,
            isOpenConfigPairing: true,
            isOpenPairing: false,
            crewTypes: [],
            restOn:CreatePairing.RESTONLIST,
            availLanguages: [],
            requestOrigin :null,
            inlineCalendar:{
                display:false,
                selectedValue:'',
                styles:{
                    left:0,
                    position:'absolute'
                }
            },
            pairingCompliments:[],
            allLanguages:[],
            crewReqChanged:false,
            pairingConfig: {
                departureType:"Not set",
                durationType:"Not set",
                dutyPeriod: 0,
                patternType:"Not set",
                pairingName: "",
                crewReq: [],
                defaultCrewReq: [],
                crewMaleReq: [],
                crewFemaleReq: [],
                crewAugmentedReq: [],
                blockType: '',
                block: {},
                fromDate:"",
                toDate:"",
                displayWeekdays: CommonLogicService.getDayOfWeeks(),
                languageReq:{},
                isMandatory:{},
                genderReq: {noOfRequiredMale:0,noOfRequiredFemale:0,id:null,version:null},
                distributionIdentifier:'',
                ignoreDuplicates:false,
                assignedProfileIds:false,
                editingProfileIds:false,
                continueIllegal:false,
                userConfirm:false,
                ignoreExpiries:false,
                restInSeat:"",
                isHeavyFlying:false,
                isCommandersDiscretion:false,
              isDispatchFlight:false,
                minConnTime: 40,
                minimumRest:"00:00",
                calculatedMinimumRest:0,
                isNightFlyNightCredit : false,
                enableNightForNightCredit : null,
                isEditPairing : false,
                base:null,
                baseBeforeFDPValidation: null,
                relatedPatterns:[],
                selectedRelatedPatterns:[],
                throwErrors:true,
                isAcmiOperation: false,
                fdpExtensionFlags: [],
                selectCompo:true,
                acmiTypeCode: null,
                remarks: '',
                remarksComment: ''
            },
            dutyChangeReasons: null,
            dutyChangeReason: null,
            dutyChangeOtherReason: '',
            defaultBase:null,
            appParam :{
            	pattern:{
            		baseListInSby:false,
                manualSplitDutyExtention : false,
                pairingRemarksEnabled: false,
                pairingRemarksCarrierList: '',
            	}

            },
            displayPairingBlock: [],
            componentView: searchPanels[0],
            restPairing:CreatePairing.getShowEventRest(),
            modeEditableFields:CreatePairing.getDisabledFieldsByMode($stateParams.mode),
          masterLists:{
            identifiers :[],
            acmiTypes : []
          },
          acModelCrewRequirement : [],
          participateACModel :  new Set(),
          defaultMinConnTime : 40,

          pairingStartDate:'',
          flightDataModel: {
            fromDate: '',
            toDate: null,
            originList: [],
            flightNumber: null,
            noOfDays: {days: 1},
            startPosition: 1,
            acModels: [],
            pageSize: 60,
            nonAssignedFlights:true,
            partialAssignedFlights:false
          },
          trainingDataModel: {
            fromDate: '',
            toDate: '',
            //program:'',
            //programDetail: '',
            startPosition: 1,
            pageSize: 100
          },
          trainingSearch:$scope.trainingSearch,
          flightSearch: $scope.flightSearch,
          carriers : [],
          carriersList : [],
          defaultCarrier : null,
          crewTypeCodes: []

        };
        vm.pairingPopOver = {
            position:'right-bottom',
            templateUrl:'fdp-details-popover.tpl.html',
            content:{

            }
        };


      //Events
        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.VIEW_MODE_CHANGE, viewModeChanged);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CREATE_PAIRING.UPDATE_LANGUAGE_LIST, updateLanguageList);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CREATE_PAIRING.PAIRING_COMPLIMENTS, updatePairingCompliments)

        EventManagerService.registerEventListener(EventManagerService.EVENT.CREATE_PAIRING.CREATE_PAIRING_SUCCESS, createPairingSuccess);

        EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ADD_OFF_TO, addDayOffTo);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ADD_OFF_TO_NEXT_DAY, addDayOffToNextDay);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ADD_OFF_TO_PREVIOUS_DAY, addDayOffToPreviousDay);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.CONVERT_TO_DEADHEAD, addDeadHeading);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.CONVERT_TO_DEADHEAD_POSITIONING, addDeadHeadPositioning);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CREATE_PAIRING.EDIT_PAIRING_SUCCESS, editPairingSuccess);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CREATE_PAIRING.FDP_FAILED_CHANGE_BASE, changePreviousBaseBeforeSelectLastEvent);

        function changePreviousBaseBeforeSelectLastEvent(){
          vm.model.pairingConfig.base = vm.model.pairingConfig.baseBeforeFDPValidation;
        }


        vm.setSingleDay = function(day){
            if (day.value==='all'){
                angular.forEach(vm.model.pairingConfig.displayWeekdays, function(date,i){
                    if (date.editable){
                        date.selected = day.selected;
                    }
                });
            }
        };

        vm.restPairingClick = function(){
            CreatePairing.setShowEventRest(vm.model.restPairing, updatePairings);
        };

        vm.submitDataForSearch = function (action, panelAction, dataModel) {
            vm.model.searchParam = angular.copy(dataModel);
            if (vm.model.searchParam!==null){
                if (vm.model.searchParam.noOfDays > 28) {
                    vm.model.viewMode = viewModes.month;
                } else if (vm.model.searchParam.noOfDays > 6) {
                    vm.model.viewMode = viewModes.week;
                } else {
                    vm.model.viewMode = viewModes.day;
                }
                CreatePairing.setSearchParamToAction(action, vm.model.searchParam);
                vm.model.viewUpdate = !vm.model.viewUpdate;
                CreatePairing.setPairingSearchCriteria(dataModel);

            }


            if (action === searchPanels[0]) {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                CreatePairing.searchPairingForFlight(
                    function (searchResults) {
                        vm.model.flightTotalRecords =  searchResults.totalRecords;
                        vm.model.flights = searchResults.flightResponseDTOs;
                        CreatePairing.setPairingFlightData(vm.model.flights);
                        ToolBarService.setViewModeCreatePairing(vm.model.viewMode);
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.VIEW_CHANGE, vm.model.viewMode);
                        //Reset view buttons on search
                        viewButtonConfigs.CREATE_PAIRING_DAY.disable = true;
                        viewButtonConfigs.CREATE_PAIRING_WEEK.disable = true;
                        viewButtonConfigs.CREATE_PAIRING_MONTH.disable = true;

                        if (vm.model.viewMode=='D'){
                            viewButtonConfigs.CREATE_PAIRING_DAY.disable = false;
                        }else if (vm.model.viewMode=='W'){
                            viewButtonConfigs.CREATE_PAIRING_DAY.disable = false;
                            viewButtonConfigs.CREATE_PAIRING_WEEK.disable = false;
                        }else{
                            viewButtonConfigs.CREATE_PAIRING_DAY.disable = false;
                            viewButtonConfigs.CREATE_PAIRING_WEEK.disable = false;
                            viewButtonConfigs.CREATE_PAIRING_MONTH.disable = false;
                        }

                        ToolBarService.setButtonConfigsToView(vm.view, viewButtonConfigs);
                        panelAction();

                        if(searchResults.length==0){
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                        }

                    },
                    function (error) {
                        MessageService.error(error);
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                    });
            }

            if (action === searchPanels[2]) {
                $timeout(function(){
                    angular.element('#btnContinue').trigger('click');
                },0);
                if (vm.model.isCrewReqValid) {
                    if (validateEvent(dataModel)){
                        vm.model.isOpenPairing = true;
                        vm.model.pairingConfig.block = dataModel;
                        vm.model.pairingConfig.blockType = CreatePairing.BLOCK_TYPE.EVENT;

                       vm.model.pairingConfig.baseBeforeFDPValidation = vm.model.pairingConfig.base;

                      if(checkSelectedBlockBeforeListedBlockForEvent(dataModel, vm.model.displayPairingBlock)) {
                        vm.model.pairingConfig.base = findListObjByValue(vm.model.crewBaseList, dataModel.startLocation.value, 'airPortCode');

                        if(vm.model.pairingConfig.base === null) {
                          vm.model.pairingConfig.base =  vm.model.defaultBase;
                        }

                      }

                        CreatePairing.setDataForFDPValidate(vm.model.pairingConfig, updatePairings);
                        panelAction();
                    }

                } else {
                    vm.model.isOpenConfigPairing = true;
                }
            }

            if (action === searchPanels[1]) {
                var requestTrainingData = CreatePairing.getPairingSearchCriteria();
                CommonMasterData.searchPairingForTrainings(requestTrainingData,
                    function (searchResults) {
                        vm.model.trainings = searchResults;
                        CreatePairing.setTrainingData(vm.model.trainings);
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.TRAINING_DATA_CHANGE, vm.model.trainings);
                        panelAction();
                    },
                    function (error) {
                        MessageService.error(error);
                    });
            }

        };

      function initialFlightPanelLoad(pairingStartDate){
        vm.model.flightDataModel.fromDate= pairingStartDate;
        vm.model.flightDataModel.nonAssignedFlights = false;
        vm.model.flightDataModel.partialAssignedFlights = false;
        vm.model.flightDataModel.noOfDays.days = 1;
        submitDataForSearchWhenPageLoad(searchPanels[0], vm.model.flightDataModel);
      }

      function initialTrainingPanelLoad(pairingStartDate){
        vm.model.trainingDataModel.fromDate= pairingStartDate;
        submitDataForSearchWhenPageLoad(searchPanels[1], vm.model.trainingDataModel);
      }

      function adaptSearchParamAndAction(action, dataModel){

        if (vm.model.searchParam.noOfDays > 28) {
          vm.model.viewMode = viewModes.month;
        } else if (vm.model.searchParam.noOfDays > 6) {
          vm.model.viewMode = viewModes.week;
        } else {
          vm.model.viewMode = viewModes.day;
        }

        CreatePairing.setSearchParamToAction(action, vm.model.searchParam);
        vm.model.viewUpdate = !vm.model.viewUpdate;
        CreatePairing.setSearchAction(action);
        CreatePairing.setPairingSearchCriteria(dataModel);
      }

      function getDataForFlightPanel(){
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
        CreatePairing.searchPairingForFlight(
          function (searchResults) {
            vm.model.flightTotalRecords =  searchResults.totalRecords;
            vm.model.flights = searchResults.flightResponseDTOs;
            CreatePairing.setPairingFlightData(vm.model.flights);
            ToolBarService.setViewModeCreatePairing(vm.model.viewMode);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.VIEW_CHANGE, vm.model.viewMode);
            //Reset view buttons on search
            viewButtonConfigs.CREATE_PAIRING_DAY.disable = true;
            viewButtonConfigs.CREATE_PAIRING_WEEK.disable = true;
            viewButtonConfigs.CREATE_PAIRING_MONTH.disable = true;

            if (vm.model.viewMode=='D'){
              viewButtonConfigs.CREATE_PAIRING_DAY.disable = false;
            }else if (vm.model.viewMode=='W'){
              viewButtonConfigs.CREATE_PAIRING_DAY.disable = false;
              viewButtonConfigs.CREATE_PAIRING_WEEK.disable = false;
            }else{
              viewButtonConfigs.CREATE_PAIRING_DAY.disable = false;
              viewButtonConfigs.CREATE_PAIRING_WEEK.disable = false;
              viewButtonConfigs.CREATE_PAIRING_MONTH.disable = false;
            }

            ToolBarService.setButtonConfigsToView(vm.view, viewButtonConfigs);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.PANEL_CLOSE);

            if(searchResults.length==0){
              EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
            }

          },
          function (error) {
            MessageService.error(error);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
          });
      }


      function getDataForTrainingPanel(){
        var requestTrainingData = CreatePairing.getPairingSearchCriteria();
        CommonMasterData.searchPairingForTrainings(requestTrainingData,
          function (searchResults) {
            vm.model.trainings = searchResults;
            CreatePairing.setTrainingData(vm.model.trainings);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.TRAINING_DATA_CHANGE, vm.model.trainings);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.PANEL_CLOSE);
          },
          function (error) {
            MessageService.error(error);
          });
      }

      function loadDataForSelectedPanel(action){
        if (action === searchPanels[0]) {
          getDataForFlightPanel()
        }

        if (action === searchPanels[1]) {
          getDataForTrainingPanel();
        }
      }

        function submitDataForSearchWhenPageLoad(action, dataModel) {
          vm.model.searchParam = dataModel;
          if (vm.model.searchParam!==null){
            adaptSearchParamAndAction(action,dataModel);
          }

          loadDataForSelectedPanel(action);

        }

        vm.getSearchPanelData = function (searchType) {
            vm.model.searchParam = CreatePairing.getSearchParamByAction(searchType);
            CreatePairing.setSearchAction(searchType);
            vm.model.componentView = searchType;
            if (searchType == searchPanels[0]) {
                vm.view = "CREATE_PAIRING_FLIGHTS";
            }

            if (searchType == searchPanels[2]) {
                vm.view = "CREATE_PAIRING_TRAININGS";
            }
            if (searchType == searchPanels[1]) {
                vm.view = "CREATE_PAIRING_EVENTS";
            }
            //set SearchWithin
            vm.model.searchWithinList = CreatePairing.getSearchWithinList();
            vm.model.options = CreatePairing.getSearchOptions();
        };

        vm.selectTraining = function (selectedTraining) {
            CommonMasterData.getTrainingProgram(selectedTraining,
                function (programsResults) {
                    vm.model.trainingPrograms = programsResults;
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        vm.selectProgram = function (selectedProgram) {
            CommonMasterData.getTrainingProgramDetails(selectedProgram,
                function (programDetailsResults) {
                    vm.model.trainingProgramDetails = programDetailsResults;
                },
                function (error) {
                    MessageService.error(error);
                }
            )
        };

        vm.addTraining = function (selectedTraining,isRestRequired) {
            $timeout(function(){
                angular.element('#btnContinue').trigger('click');
            },0);

            setDefaultCrewReqForTraining();

            if (vm.model.isCrewReqValid) {
                vm.model.isOpenConfigPairing = true;
                if (validateTraining(selectedTraining)){
                    vm.model.isOpenPairing = true;
                    vm.model.pairingConfig.block = selectedTraining;
                    vm.model.pairingConfig.blockType = CreatePairing.BLOCK_TYPE.TRAINING;
                    vm.model.pairingConfig.baseBeforeFDPValidation = vm.model.pairingConfig.base;
                    vm.model.pairingConfig.isRestRequired = isRestRequired;
                    if(vm.model.pairingConfig.base === null || vm.model.pairingConfig.base === undefined) {
                      vm.model.pairingConfig.base =  vm.model.defaultBase;
                    }

                    CreatePairing.setDataForFDPValidate(vm.model.pairingConfig, updatePairings);
                    clearDefaultCrewReqForTraining();
                }
            } else {
                vm.model.isOpenConfigPairing = true;
            }
        };


        function setDefaultCrewReqForTraining(){

        	if(vm.model.displayPairingBlock != null && vm.model.displayPairingBlock.length == 0){
        		vm.model.trainingOnlyPattern = true;
        	}

        	if(vm.model.trainingOnlyPattern){
        		vm.model.isCrewReqValid = true;
            	vm.model.pairingConfig.crewReq["CP"] = 1;
        	}

        }

        function clearDefaultCrewReqForTraining(){
        	if(vm.model.trainingOnlyPattern){
        		vm.model.isCrewReqValid = false;
            	vm.model.pairingConfig.crewReq = [];
            	vm.model.fdpValidFlag = true;
        	}
        }

        vm.bottomPairingOpen = function () {
            vm.model.isOpenPairing = !vm.model.isOpenPairing;
        };

        vm.bottomPairingConfigToggle = function () {
            vm.model.isOpenConfigPairing = !vm.model.isOpenConfigPairing;
             if (vm.model.isOpenConfigPairing && vm.model.displayPairingBlock.length!==0){
                CreatePairing.getLanguagesForAirPorts(vm.model.availLanguages);
            }
        };

        vm.dblClickOnBlock = function (selectedBlock) {
          vm.model.participateACModel = new Set();
           getAvailableACModelsInPattern();
          vm.model.pairingConfig.defaultCrewReq =  vm.model.acModelCrewRequirement[selectedBlock.modelNo];
          vm.model.participateACModel.add(selectedBlock.modelNo);
          setMaxCrewRequirementByACModel(vm.model.participateACModel);
          setMinConnectionTimeByACModel(vm.model.participateACModel);
          validateCrewRequirement();
            $timeout(function(){
                angular.element('#btnContinue').trigger('click');
            },0);
            if (vm.model.isCrewReqValid) {
                vm.model.isOpenPairing = true;
				vm.model.pairingConfig.isRestRequired = true;
                vm.model.isOpenConfigPairing = true;
                vm.model.pairingConfig.block = selectedBlock;
                vm.model.pairingConfig.isRestRequired = true;
                var displayBlock = vm.model.displayPairingBlock;
                vm.model.pairingConfig.baseBeforeFDPValidation = vm.model.pairingConfig.base;
                if(checkSelectedBlockBeforeListedBlock(selectedBlock, displayBlock)) {
                  var selectedBlockBase = findListObjByValue(vm.model.crewBaseList, selectedBlock.origin, 'airPortCode');

                  if(selectedBlockBase != null) {
                    vm.model.pairingConfig.base = selectedBlockBase;
                  }
                }

              if (vm.model.pairingConfig.base === null || vm.model.pairingConfig.base === "") {
                MessageService.error(MessageService.MESSAGES.CREATE_PAIRING.BASE_MISSING);
              }else {
                vm.model.pairingConfig.blockType = CreatePairing.BLOCK_TYPE.FLIGHT;
                CreatePairing.setDataForFDPValidate(vm.model.pairingConfig, updatePairings);
              }
            } else {
                vm.model.isOpenConfigPairing = true;
            }
          CreatePairing.getLanguagesForAirPorts(vm.model.availLanguages);
        };

      function checkSelectedBlockBeforeListedBlock(selectedBlock, displayBlock){
        var isBeforeListedBlock = false;
        var startTime = new Date(selectedBlock.estimatedDepartureDate+ " " + selectedBlock.estimatedDepartureTime).getTime();

        if(displayBlock.length == 0){
          isBeforeListedBlock = true;
        }else {
          var displayTimeStart = new Date(displayBlock[0].blockStartDateStr + " " + displayBlock[0].blockStartTimeStr).getTime();

          if(startTime < displayTimeStart){
            isBeforeListedBlock = true;
          }
        }

        return isBeforeListedBlock;
      }

      function checkSelectedBlockBeforeListedBlockForEvent(selectedBlock, displayBlock){
        var isBeforeListedBlock = false;
        var startTime = new Date(selectedBlock.fromDate.value+ " " + selectedBlock.startTime.value).getTime();

        if(displayBlock.length == 0){
          isBeforeListedBlock = true;
        }else {
          var displayTimeStart = new Date(displayBlock[0].blockStartDateStr + " " + displayBlock[0].blockStartTimeStr).getTime();

          if(startTime < displayTimeStart){
            isBeforeListedBlock = true;
          }
        }

        return isBeforeListedBlock;
      }


          vm.continueConfig = function () {
            vm.frmCreatePairing.$valid = false;
            validateCrewRequirement();
            if (vm.model.isCrewReqValid && vm.model.pairingConfig.base){
                vm.model.isOpenConfigPairing = true;
                vm.model.fdpValidFlag = true;
            }

            if (vm.frmCreatePairing.$valid) {
                vm.frmCreatePairing.$submitted=false;
            }
        };

        vm.resetPairing = function(){
            vm.model.fdpValidFlag = false;
            vm.model.pairingSaveValidFlag = false;
            vm.frmCreatePairing.$submitted = false;
            vm.model.isCrewReqValid = false;
            vm.model.isMinimumRestValid = false;
            vm.model.minimumRestValidationMsg = "";
            vm.model.displayPairingBlock = [];
            vm.model.crewReqChanged = false;
            vm.model.pairingConfig = {
                departureType:"Not set",
                durationType:"Not set",
                dutyPeriod:0,
                patternType:"Not set",
                pairingName: "",
                base:"",
                crewReq: [],
                crewAugmentedReq: [],
                blockType: '',
                block: {},
                fromDate:"",
                toDate:"",
                displayWeekdays: CommonLogicService.getDayOfWeeks(),
                languageReq:{},
                genderReq: {},
                distributionIdentifier:' ',
                ignoreDuplicates:false,
                assignedProfileIds:false,
                editingProfileIds:false,
                continueIllegal:false,
                userConfirm:false,
                ignoreExpiries:false,
                restInSeat:"",
                isHeavyFlying:false,
                isCommandersDiscretion:false,
              isDispatchFlight:false,
                minimumRest : "00:00",
                calculatedMinimumRest: 0,
                isNightFlyNightCredit : false,
              isAcmiOperation : false

            }
            vm.model.remarksValidationError = false;
            vm.model.remarksCommentValidationError = false;
            CreatePairing.resetValidationByBlockList();
        };

        vm.setCrewRequirement = function(){
            validateCrewRequirement();
            vm.model.crewReqChanged = true;
        };

        vm.savePairing = function () {
            vm.model.pairingSaveValidFlag = true;
            validateCrewRequirement();

            if(vm.model.pairingConfig.isEditPairing
              && vm.model.pairingConfig.selectedRelatedPatterns.length==0){
              MessageService.error(MessageService.MESSAGES.CREATE_PAIRING.BULK_UPDATE_PAIRING_SELECTION_MISSING);
            }
            else if (vm.model.pairingConfig.acmiTypeCode == null && vm.model.pairingConfig.isAcmiOperation === true) {
              MessageService.error(MessageService.MESSAGES.CREATE_PAIRING.ACMI_OPERATION_WITHOUT_ACMI_TYPE);

            }else {

              vm.frmCreatePairing.$setSubmitted();
              $timeout(function () {
                if (vm.model.fdpValidFlag &&
                  vm.frmCreatePairing.$error !== {} &&
                  vm.frmCreatePairing.$valid &&
                  validateFDPBeforeSubmit() &&
                  validateMinimumRest() &&
                  validateRemarksBeforeSubmit() &&
                  vm.model.isCrewReqValid
                // && validateLanguageRequirementBeforeSubmit()
                ) {
                    CreatePairing.saveDataForPairing(vm.model.pairingConfig);
                }
              }, 0);
            }

            if(angular.equals(vm.model.pairingConfig.genderReq, {})){
              vm.model.pairingConfig.genderReq.noOfRequiredMale=0;
              vm.model.pairingConfig.genderReq.noOfRequiredFemale=0;
            }
        };


        function validateLanguageRequirementBeforeSubmit(){
            var send = true;
            var cabinCrewCount = 0;
            var languageReqCount = 0;

            var cabinCrewArray = [];
            angular.forEach(vm.model.crewTypes, function(crewType) {
            	if(crewType.crewTypeMasterCode == 'CC'){
            		cabinCrewArray.push(crewType.crewTypeCode);
            	}
            });

            if(vm.model.pairingConfig){

            	 angular.forEach(cabinCrewArray, function(cabinCrew) {
            		if(vm.model.pairingConfig.crewReq[cabinCrew] !== ""){
            			cabinCrewCount += parseInt(vm.model.pairingConfig.crewReq[cabinCrew],0);
            		}
                 });

            	 angular.forEach(vm.model.pairingConfig.languageReq, function(value,lang) {
             		languageReqCount += parseInt(value,0);
                 });

            }

            if(cabinCrewCount < languageReqCount){
            	send = false;
            	MessageService.error(MessageService.MESSAGES.CREATE_PAIRING.LANG_REQUREMENT);
            }

            return send
        }

         vm.removePairingFromList = function (block) {
            if(vm.model.mode.toLowerCase()!=='copy'){

               if(vm.model.trainingOnlyPattern){
            	   setDefaultCrewReqForTraining();
               }
                setBaseWhenRemovePairing(block, vm.model.displayPairingBlock);
               removeFdpFlags(block);
               CreatePairing.removeBlocksFromList(vm.model.pairingConfig, block, true, updatePairings);
            }
            vm.model.participateACModel = new Set();
            getAvailableACModelsInPattern();
            if (vm.model.participateACModel.size !== 0) {
              setMaxCrewRequirementByACModel(vm.model.participateACModel);
            }
            setMinConnectionTimeByACModel(vm.model.participateACModel);
            validateCrewRequirement();
        };

        function removeFdpFlags(blocks) {
          // remove related FDP flags for a block in pairing (from fdpExtensionFlags)
          const removedBlockSeqNo = getRemovedBlockSeqNo(blocks);
          const fdpFlagIndex = vm.getFdpFlagIndex(removedBlockSeqNo);

          if(removedBlockSeqNo !== -1 && fdpFlagIndex !== -1) {
            vm.model.pairingConfig.fdpExtensionFlags = vm.model.pairingConfig.fdpExtensionFlags.filter(function(flag) {
              return flag.blockSeqNo !== removedBlockSeqNo;
            });

            rearrangeFdpFlags(fdpFlagIndex)
          }
        }

        function getRemovedBlockSeqNo(blocks) {
          var blockSeqNo = -1;

          for(let i=0; i<vm.model.displayPairingBlock.length; i++){
            if(vm.model.displayPairingBlock[i].blockDetailList === blocks){
              blockSeqNo = vm.model.displayPairingBlock[i].blockSeqNo;
              break;
            }
          }

          return blockSeqNo;
        }

        function rearrangeFdpFlags(fdpFlagIndex) {
          if(fdpFlagIndex >= vm.model.pairingConfig.fdpExtensionFlags.length) {
            return;
          }

          // from the passed FDP flag index onwards, decrement the blockSeqNo of each flag by 1
          for(let i=fdpFlagIndex; i<vm.model.pairingConfig.fdpExtensionFlags.length; i++) {
            vm.model.pairingConfig.fdpExtensionFlags[i].blockSeqNo -= 1;
          }
        }

        function setBaseWhenRemovePairing(deleteBlock, blockList) {
          var removedBlock = [];
          if(deleteBlock[0] === undefined){
            removedBlock.push(deleteBlock);
          }else{
            removedBlock = deleteBlock;
          }

          var finalBlockDetailAfterRemoving = getBlockListAfterRemoving(getDetailBlock(blockList), removedBlock);
          vm.model.pairingConfig.baseBeforeFDPValidation = vm.model.pairingConfig.base;
          vm.model.pairingConfig.base = finalBlockDetailAfterRemoving.length !== 0 ?  findListObjByValue(vm.model.crewBaseList, finalBlockDetailAfterRemoving[0].startLocation, 'airPortCode') : null;

          if(vm.model.pairingConfig.base === null){
            vm.model.pairingConfig.base = vm.model.pairingConfig.baseBeforeFDPValidation;
          }

        }

        function getDetailBlock(blockList){
          var blockDetailList = [];

          for (var i=0; i<blockList.length; i++) {
            var blockDetail = blockList[i].blockDetailList;
            for (var j=0; j < blockDetail.length; j++) {
              blockDetailList.push(blockDetail[j]);
            }
          }

          return blockDetailList;
        }

        function getBlockListAfterRemoving(blockDetailList, removedBlock){
          var finalBlockDetailAfterRemoving = [];
          angular.forEach(blockDetailList, function(blockDetail) {
            angular.forEach(removedBlock, function(removedBlockDetail) {
              if(blockDetail.slotId !== removedBlockDetail.slotId){
                finalBlockDetailAfterRemoving.push(blockDetail);
              }
            });
          });

          return finalBlockDetailAfterRemoving;
        }

        vm.dateFormatted = function(dataText){
            return moment(dataText,'DD/MM/YYYY').format('DD/MM');
        };

        vm.onClickFDP = function(e, pairBlock){
            var findPosition = function(){
                var H = 'left',V='bottom';
                if((e.clientX + e.target.offsetWidth + 240) > window.innerWidth){
                    H = 'left';
                }else{
                    H = 'right';
                }

                return H + '-' + V;
            };
            vm.pairingPopOver.position = findPosition();
            vm.pairingPopOver.content = {
                startTime: pairBlock.fdpStart,
                endTime: pairBlock.blockEndDateStr,
                noOfLegs: pairBlock.sectors,
                currentDutyPeriod: CommonLogicService.getHoursByMinutes(pairBlock.dutyPeriod),
                maxFDPLimit: CommonLogicService.getHoursByMinutes(pairBlock.maxFdp),
                blockName: pairBlock.blockName,
                extendedFDPSplitDuty:CommonLogicService.getHoursByMinutes(pairBlock.extendedFdpSplitDuty)
            };
        };

        vm.closePopover = function(){
            $timeout(function(){
                angular.element('html').trigger('click');
            },0);
        };

        vm.getPatternMenu = function(type, block){
            selectedBlockForContextMenu = block;
            var popupType =  type;
            if( getEventByCode('OFF') === null){
              if(type === 'PAIRING_CONVERT') {
                var popupType = 'PAIRING_CONVERT_NO_OFF_RELEVANT';
              }if(type === 'DAY_OFF'){
                var popupType = '';
              }
            }

            if(getEventByCode('OFF') === null && popupType === 'DAY_OFF_ONLY'){
                return;
            }

            return ContextMenuService.getContextMenu(popupType);
        };

        vm.setDurationForRest = function (startDate, startTime, endDate, endTime) {
            return CommonLogicService.calculateDutyHours(startDate, startTime, endDate, endTime);
        };

        vm.selectADateForOff = function(){
            vm.model.inlineCalendar.display = false;
            validateCrewRequirement();
            if (vm.model.isCrewReqValid && vm.model.pairingConfig.base){
                var event = CreatePairing.searchPanelEvent();
                event.selectedEvent = getEventByCode('OFF');
                event.fromDate.value  = moment(vm.model.inlineCalendar.selectedValue, 'DD/MM/YYYY').format('DD/MM/YYYY');
                event.toDate.value  = moment(vm.model.inlineCalendar.selectedValue, 'DD/MM/YYYY').format('DD/MM/YYYY');
                vm.model.pairingConfig.block = event;
                vm.model.pairingConfig.blockType = CreatePairing.BLOCK_TYPE.EVENT;
                CreatePairing.setDataForFDPValidate(vm.model.pairingConfig, updatePairings);
            }else{
                vm.model.isOpenConfigPairing = true;
                vm.model.fdpValidFlag = false;
            }
        };

        vm.changeDateTime = function(flg){
            if (vm.model.pairingConfig.toDate && vm.model.pairingConfig.fromDate){
                if ('fromDate' == flg){
                    vm.model.pairingConfig.toDate = vm.model.pairingConfig.fromDate;
                }

                 //setDaySelected(vm.model.pairingConfig.fromDate, vm.model.pairingConfig.toDate)
                CommonLogicService.applyDaySelection(vm.model.pairingConfig.displayWeekdays, vm.model.pairingConfig.fromDate, vm.model.pairingConfig.toDate)
                }
        };

        vm.isDisabledMe = function(myName){
            return vm.model.modeEditableFields.indexOf(myName)>-1;
        };

        vm.notifyPairingCompliments = function () {
            updatePairingCompliments(vm.model.pairingCompliments);
        }

      vm.checkMinRestValue = function (value) {
        var restValue = vm.model.pairingConfig.minimumRest;
        if (restValue === null || restValue === "") {
          vm.model.pairingConfig.minimumRest = "00:00";
        }
      };

      function validateMinimumRest() {

          if(CreatePairing.adeptMinimumRestToMin(vm.model.pairingConfig.minimumRest) < vm.model.pairingConfig.calculatedMinimumRest){
            vm.model.isMinimumRestValid = false;
            vm.model.minimumRestValidationMsg = "Minimum Rest cannot be less than " + CommonLogicService.getHoursByMinutes(vm.model.pairingConfig.calculatedMinimumRest);
            return false;
          }else{
            vm.model.isMinimumRestValid = true;
            return true;
          }


      }

        function validateTraining(training){
            if (training.trainingProgram==undefined){
                MessageService.error("Training program is required!");
                return false;
            }else if(training.trainingProgramDetail==undefined){
                MessageService.error("Program detail is required!");
                return false;
            }
            return true;
        }

      function showLoader(flag) {
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
          flag: flag,
          target: 'configDistribution',
          animationName: 'crewing-loader'
        });
      }


        function validateEvent(eventModel){
            if (eventModel.selectedEvent.eventCode==='SBY' && $.trim(eventModel.aircraftType.value)==="" && eventModel.aircraftType===true){
                if (CreatePairing.checkMasterCrewTypeInCrewRequirement(vm.model.pairingConfig.crewReq, 'FC')){
                    MessageService.error("Aircraft type is required!");
                    return false;
                }
                return true;
            }else if (eventModel.selectedEvent.eventCode==='SBY' && $.trim(eventModel.startLocation.value)==="") {
                MessageService.error("Start location is required!");
                return false;
            }else{
                return true;
            }

        }

        function validateCrewRequirement() {
            vm.model.isCrewReqValid = false;
            for (var key in vm.model.pairingConfig.crewReq) {
                if (vm.model.pairingConfig.crewReq.hasOwnProperty(key)) {
                    if (vm.model.pairingConfig.crewReq[key] !== "" && parseInt(vm.model.pairingConfig.crewReq[key],0) !== 0) {
                        vm.model.isCrewReqValid = true;
                        vm.model.trainingOnlyPattern = false;
                        break;
                    }
                }
            }
        }

        function validateFDPBeforeSubmit(){
            var send = true;
            if(vm.model.displayPairingBlock.length===0){
                vm.model.isOpenPairing = true;
                MessageService.error(MessageService.MESSAGES.CREATE_PAIRING.CHECK_FDP_ENTRY);
                send = false;
            }
            return send
        }

        function computePairingRemarksEnabled() {
            var carrierList = vm.model.appParam.pattern.pairingRemarksCarrierList;
            var carrier = vm.model.appParam.carrierCode;
            if (!carrier || !carrierList || carrierList.trim() === '') {
                vm.model.appParam.pattern.pairingRemarksEnabled = false;
                return;
            }
            var enabled = false;
            angular.forEach(carrierList.split(','), function(code) {
                if (code.trim().toLowerCase() === carrier.toLowerCase()) {
                    enabled = true;
                }
            });
            vm.model.appParam.pattern.pairingRemarksEnabled = enabled;
        }

        function validateRemarksBeforeSubmit() {
            vm.model.remarksValidationError = false;
            vm.model.remarksCommentValidationError = false;

            if((!vm.model.pairingConfig.remarks || vm.model.pairingConfig.remarks.trim() === '')
            && (vm.model.pairingConfig.remarksComment && vm.model.pairingConfig.remarksComment.trim() !== '')){
                vm.model.remarksValidationError = true;
                MessageService.error(MessageService.MESSAGES.CREATE_PAIRING.REMARKS_NOT_SELECTED);
                return false;
            }

            if (vm.model.pairingConfig.remarks === 'Other' &&
                (!vm.model.pairingConfig.remarksComment || vm.model.pairingConfig.remarksComment.trim() === '')) {
                vm.model.remarksCommentValidationError = true;
                MessageService.error(MessageService.MESSAGES.CREATE_PAIRING.REMARKS_REQUIRED);
                return false;
            }

            if (!vm.model.appParam.pattern.pairingRemarksEnabled) {
                return true;
            }
            var hasFlag = false;
            angular.forEach(vm.model.pairingConfig.fdpExtensionFlags, function(flag) {
                if (flag.extension || flag.discretion || flag.splitDutyExtension) {
                    hasFlag = true;
                }
            });
            if (hasFlag && (!vm.model.pairingConfig.remarks || vm.model.pairingConfig.remarks.trim() === '')) {
                vm.model.remarksValidationError = true;
                MessageService.error(MessageService.MESSAGES.CREATE_PAIRING.REMARKS_REQUIRED);
                return false;
            }
            return true;
        }

        function validateLanguageRequirementBeforeSubmit(){
            var send = true;
            var cabinCrewCount = 0;
            var languageReqCount = 0;

            var cabinCrewArray = [];
            angular.forEach(vm.model.crewTypes, function(crewType) {
            	if(crewType.crewTypeMasterCode == 'CC'){
            		cabinCrewArray.push(crewType.crewTypeCode);
            	}
            });

            if(vm.model.pairingConfig){

            	 angular.forEach(cabinCrewArray, function(cabinCrew) {
            		if(vm.model.pairingConfig.crewReq[cabinCrew] !== ""){
            			cabinCrewCount += parseInt(vm.model.pairingConfig.crewReq[cabinCrew],0);
            		}
                 });

            	 angular.forEach(vm.model.pairingConfig.languageReq, function(value,lang) {
             		languageReqCount += parseInt(value,0);
                 });

            }

            if(cabinCrewCount < languageReqCount){
            	send = false;
            	MessageService.error(MessageService.MESSAGES.CREATE_PAIRING.LANG_REQUREMENT);
            }

            return send
        }


        function viewModeChanged(data){
            if (data.view == vm.view) {
                vm.model.viewMode = data.mode;
                ToolBarService.setViewModeCreatePairing(vm.model.viewMode);
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.VIEW_CHANGE, vm.model.viewMode);
            }
        }

        function updatePairings(data){
        var updatedForMonthRange = false;
            if(!vm.model.pairingConfig.isEditPairing){
              vm.model.pairingConfig.pairingName =  CreatePairing.getPatternName();
            }
            if(vm.model.trainingOnlyPattern){
            	clearDefaultCrewReqForTraining();
            }

            // update fdp flags
            vm.model.pairingConfig.fdpExtensionFlags = [];
            data.blockDTO.forEach(function(block) {
              vm.model.pairingConfig.fdpExtensionFlags.push({
                legIds: getFlightLegIdsFromBlock(block),
                extension: block.extension,
                discretion: block.discretion,
                splitDutyExtension: block.splitDutyExtension
              });
            });

            if(data.blockDTO.length > 0) {
              vm.model.pairingConfig.base = findListObjByValue(vm.model.crewBaseList, data.blockDTO[0].startLocation, 'airPortCode');
            } else {
              vm.model.pairingConfig.base = null;
            }

          if(vm.model.pairingConfig.base === null) {
            var index = vm.model.modeEditableFields.indexOf('baseAirPortCode');
            if (index > -1) {
              vm.model.modeEditableFields.splice(index, 1);
            }
            if(data.blockDTO.length > 0){
              MessageService.error("Select base");
            }
          }else{
            var index = vm.model.modeEditableFields.indexOf('baseAirPortCode');
            if ((index === -1)) {
              vm.model.modeEditableFields.push('baseAirPortCode');
            }
          }
            vm.model.displayPairingBlock =[];
            vm.model.displayPairingBlock = data.blockDTO;
            vm.model.pairingConfig.durationType = data.durationType;
            vm.model.pairingConfig.departureType = data.departureType;
            vm.model.pairingConfig.patternType = data.patternType;
            var pairingStart = CreatePairing.getBlockRelateMonthByIndex('start', 'blockStartDateStr', data.blockDTO);
            var pairingEnd = CreatePairing.getBlockRelateMonthByIndex('end', 'blockEndDateStr', data.blockDTO);
            if(vm.model.pairingConfig.fromDate == "" || vm.model.pairingConfig.fromDate == null){
            	vm.model.pairingConfig.fromDate =  moment(pairingStart,'DD/MM/YYYY').startOf('month').format('DD/MM/YYYY');
            	vm.model.pairingConfig.toDate =  moment(pairingEnd,'DD/MM/YYYY').endOf('month').format('DD/MM/YYYY');
              updatedForMonthRange = true;
            }
            if(!updatedForMonthRange && (vm.model.pairingConfig.fromDate !== pairingStart || vm.model.pairingConfig.toDate !== pairingEnd)){
              vm.model.pairingConfig.selectedRelatedPatterns = updateRealtedPatternInfo(vm.model.pairingConfig.selectedRelatedPatterns,vm.model.pairingId) ;
              vm.model.pairingConfig.relatedPatterns = updateRealtedPatternInfo(vm.model.pairingConfig.relatedPatterns,vm.model.pairingId) ;
              vm.model.pairingConfig.selectCompo = !vm.model.pairingConfig.selectCompo
            }
            vm.changeDateTime('toDate');
            if(data.blockDTO.length > 0) {
              vm.model.pairingConfig.dutyPeriod = CreatePairing.getDutyPeriodByMinutes(data.dutyPeriod);
              vm.model.pairingConfig.calculatedMinimumRest= data.minimumRestInMin;
              vm.model.pairingConfig.minimumRest = CommonLogicService.getHoursByMinutes(data.minimumRestInMin);
            }else{
              vm.model.pairingConfig.dutyPeriod = CreatePairing.getDutyPeriodByMinutes(0);
              vm.model.pairingConfig.calculatedMinimumRest= 0;
              vm.model.pairingConfig.minimumRest = CommonLogicService.getHoursByMinutes(0);
            }

        }

      function updateRealtedPatternInfo(selectedRelatedPatterns, patternId) {
        var updatedPatterns = selectedRelatedPatterns.map(function (pattern) {
          if (patternId == pattern.patternId) {
            return {
              patternId: pattern.patternId,
              patternStartDateStr: vm.model.pairingConfig.fromDate,
              patternEndDateStr: vm.model.pairingConfig.toDate,
              patternDayDisc: updatePatternDayDisc(vm.model.pairingConfig.fromDate)
            };
          } else {
            return pattern;
          }
        });
        return updatedPatterns;
      }

      function updatePatternDayDisc(dateString) {
        var date = moment(dateString, "DD/MM/YYYY");
        var dayAbbreviation = date.format("ddd");
        return dayAbbreviation + " " + dateString;
      }

        function updateLanguageList(data){
            vm.model.availLanguages = [];
            angular.forEach(data, function(lang){
                var tempLang = CreatePairing.getLanguageForPairings();
                tempLang.langCode = lang.languageCode || lang.langCode;
                tempLang.languageDesc = lang.languageDescription || lang.languageDesc;
                if (lang.requiredCrew != null && lang.minReqCrew != null){
                  tempLang.minReqCrew = lang.requiredCrew || lang.minReqCrew;
                }else if (lang.requiredCrew != null){
                  tempLang.minReqCrew = lang.requiredCrew;
                }else if (lang.minReqCrew != null){
                  tempLang.minReqCrew = lang.minReqCrew;
                }

                if (lang.assignedCrew != null && lang.noOfCrew != null){
                  tempLang.noOfCrew = lang.assignedCrew || lang.noOfCrew;
                }else if (lang.assignedCrew != null){
                  tempLang.noOfCrew = lang.assignedCrew;
                }else if (lang.noOfCrew != null){
                  tempLang.noOfCrew = lang.noOfCrew;
                }

                vm.model.availLanguages.push(tempLang);

                if(!vm.model.pairingConfig.isMandatory) {
                  var json = { }
                  for (var i = 0; i < lang.length; i++) {
                    json[x.langCode] = null;
                  }
                  vm.model.pairingConfig.isMandatory = json;
                }

                vm.model.pairingConfig.isMandatory[tempLang.langCode] = lang.isMandatory;

                if(!vm.model.pairingConfig.languageReq[tempLang.langCode]){
                  vm.model.pairingConfig.languageReq[tempLang.langCode] = tempLang.minReqCrew >= 0 ? tempLang.minReqCrew : '';
                }
            });
        }


      function updatePairingCompliments(res){
        if(!angular.equals(res,[])) {
          vm.model.pairingCompliments = res;
          var req;
          var languages;
          if (vm.model.pairingConfig.isHeavyFlying || res.length==1) {
            req = res[0];
            languages = req.configForLangCompliment;

            angular.forEach(req.configForCrewCompliment, function (crewTypeRequiment) {
              vm.model.pairingConfig.crewReq[crewTypeRequiment.crewTypeCode] = crewTypeRequiment.reqCrew;
              // !!!vm.model.pairingConfig.crewReq[crewTypeRequiment.crewTypeCode] || vm.model.pairingConfig.crewReq[crewTypeRequiment.crewTypeCode] < crewTypeRequiment.reqCrew
              //   ? crewTypeRequiment.reqCrew : vm.model.pairingConfig.crewReq[crewTypeRequiment.crewTypeCode];

            });

          } else {
            req = res[1];
            languages = req.configForLangCompliment;

            angular.forEach(req.configForCrewCompliment, function (crewTypeRequiment) {
              vm.model.pairingConfig.crewReq[crewTypeRequiment.crewTypeCode] = crewTypeRequiment.reqCrew;
              // !!!vm.model.pairingConfig.crewReq[crewTypeRequiment.crewTypeCode] || vm.model.pairingConfig.crewReq[crewTypeRequiment.crewTypeCode] < crewTypeRequiment.reqCrew
              //   ? crewTypeRequiment.reqCrew : vm.model.pairingConfig.crewReq[crewTypeRequiment.crewTypeCode];

            });

          }

          vm.model.availLanguages = [];
          angular.forEach(languages, function (lang) {
            var tempLang = CreatePairing.getLanguageForPairings();
            tempLang.langCode = lang.languageCode || lang.langCode;

            angular.forEach(vm.model.languages, function (lang) {
              if(lang.languageCode == tempLang.langCode){
                tempLang.languageDesc = lang.languageDesc;
              }

            });

            // tempLang.languageDesc = lang.languageDescription || lang.languageDesc;
            tempLang.minReqCrew = lang.requiredCrew || lang.minReqCrew;
            tempLang.noOfCrew = lang.assignedCrew || lang.noOfCrew;
            vm.model.availLanguages.push(tempLang);

            vm.model.pairingConfig.languageReq[tempLang.langCode] = tempLang.minReqCrew;
            vm.model.pairingConfig.isMandatory[tempLang.langCode] = tempLang.isMandatory;

          });

          CreatePairing.setPairingLanguageCrew(languages);
        }
      }

      CreatePairing.searchLanugages(
        function(langCatList){
          vm.model.languages= langCatList;
        },
        function(error){
          MessageService.error(error);
        }
      );

        function setCrewRequirement(crewReqModel){
            angular.forEach(crewReqModel, function(crewR){
                vm.model.pairingConfig.crewReq[crewR.crewTypeCode] =  crewR.assignedCrew===0?'':crewR.assignedCrew;
                vm.model.pairingConfig.crewMaleReq[crewR.crewTypeCode] =  crewR.minimumMaleReq===0?'':crewR.minimumMaleReq;
                vm.model.pairingConfig.crewFemaleReq[crewR.crewTypeCode] =  crewR.minimumFemaleReq===0?'':crewR.minimumFemaleReq;
                vm.model.pairingConfig.crewAugmentedReq[crewR.crewTypeCode] =  crewR.augmentedCrew===0?'':crewR.augmentedCrew;
            });
        }

        function setGenderRequirement(genderReqModel) {
          vm.model.pairingConfig.genderReq.noOfRequiredFemale = genderReqModel.requiredFemaleCrew!==null?genderReqModel.requiredFemaleCrew:0;
          vm.model.pairingConfig.genderReq.noOfRequiredMale =  genderReqModel.requiredMaleCrew!==null?genderReqModel.requiredMaleCrew:0;
          vm.model.pairingConfig.genderReq.id = genderReqModel.patternGenderReqId;
          vm.model.pairingConfig.genderReq.version = genderReqModel.version;
        }

        function setMaxCrewRequirementByACModel(patternACModles) {
          if(!vm.model.crewReqChanged || vm.model.displayPairingBlock.length<1){
            vm.model.pairingConfig.crewReq = [];
            angular.forEach(patternACModles, function (patternACModel) {
              angular.forEach(vm.model.acModelCrewRequirement[patternACModel], function (crewTypeRequiment) {
                vm.model.pairingConfig.crewReq[crewTypeRequiment.crewType] =
                  !!!vm.model.pairingConfig.crewReq[crewTypeRequiment.crewType] || vm.model.pairingConfig.crewReq[crewTypeRequiment.crewType] < crewTypeRequiment.minCrewReq
                    ? crewTypeRequiment.minCrewReq : vm.model.pairingConfig.crewReq[crewTypeRequiment.crewType];

              });
            });
          }

        }

        function getAvailableACModelsInPattern(){
          angular.forEach( _.keys(_.groupBy(CreatePairing.getListByBlockTypeFlight(),'modelNo')),function (acModel) {
            vm.model.participateACModel.add(acModel);
          });
        }

      function setMinConnectionTimeByACModel(patternACModles) {
          vm.model.pairingConfig.minConnTime =  vm.model.defaultMinConnTime;
        angular.forEach(patternACModles, function (patternACModel) {
          angular.forEach( _.groupBy(vm.model.airCraftTypes, 'airCraftType')[patternACModel], function (acType) {
            vm.model.pairingConfig.minConnTime =
              !!!vm.model.pairingConfig.minConnTime || vm.model.pairingConfig.minConnTime > acType.minGroundTime
                ? acType.minGroundTime : vm.model.pairingConfig.minConnTime;

          });
        });
      }

        function createPairingSuccess() {
            vm.resetPairing();
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.VIEWPORT_DATA_CHANGE);
        }

        function editPairingSuccess() {
          if(vm.model.requestOrigin === "crewSchedule"){
            refreshCrewScheduleAndConfirmClose()
          }
        }

      function refreshCrewScheduleAndConfirmClose(){

        var details = {
          title: 'Confirmation',
          messages: [MessageService.MESSAGES.CREATE_PAIRING.CLOSE_PAIRING_TABS]
        };

        PopupManager.openModal('CONFIRM_DIALOG', details, confirmClose);

        function confirmClose(param) {
          var tabLocalData = StorageServices.getTabData('crewSchedule');

          if(param === 'YES'){
            window.open('', 'managePairing').close();
            window.close();
          }

          TabService.gotoTab('crewSchedule', {
            crewId : tabLocalData.crewingParams.crewId,
            time   : (new Date()).getTime()
          });
        }

      }

        function getNextSetOfRecords(){
            vm.model.searchParam.startPosition = vm.model.searchParam.startPosition + vm.model.searchParam.pageSize;
            if(vm.model.searchParam.startPosition<vm.model.flightTotalRecords){
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                    flag: true,
                    target: 'createPairingFlights',
                    animationName: 'crewing-loader'
                });
                var flightsReq = CreatePairing.getSearchParam(vm.model.searchParam);
                CreatePairing.appendPairingForFlight(flightsReq,
                    function (searchResults) {
                        vm.model.flightTotalRecords =  searchResults.totalRecords;
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.APPEND_FLIGHT_DATA, searchResults.flightResponseDTOs);
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                            flag: false,
                            target: 'createPairingFlights',
                            animationName: 'crewing-loader'
                        });
                    },
                    function (error) {
                        MessageService.error(error);
                    });
            }
        }


            function addDayOffTo(params){
                var leftPos = params.event.clientX + 50;
                vm.model.inlineCalendar.display = true;
                vm.model.inlineCalendar.styles.left = leftPos;
            }

            function addDayOffToNextDay(){
                var event = CreatePairing.searchPanelEvent();
                var blockInfo = getInforFromBlock(selectedBlockForContextMenu);
                event.selectedEvent = getEventByCode('OFF');
                event.fromDate.value  = moment(blockInfo.endDate, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY');
                event.toDate.value  = moment(blockInfo.endDate, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY');
                vm.model.pairingConfig.block = event;
                vm.model.pairingConfig.blockType = CreatePairing.BLOCK_TYPE.EVENT;
                vm.model.pairingConfig.baseBeforeFDPValidation = vm.model.pairingConfig.base;
                CreatePairing.setDataForFDPValidate(vm.model.pairingConfig, updatePairings);
            }

            function addDayOffToPreviousDay(){
                var event = CreatePairing.searchPanelEvent();
                var blockInfo = getInforFromBlock(selectedBlockForContextMenu);
                event.selectedEvent = getEventByCode('OFF');
                event.fromDate.value  = moment(blockInfo.startDate, 'DD/MM/YYYY').add( -1, 'days').format('DD/MM/YYYY');
                event.toDate.value  = moment(blockInfo.startDate, 'DD/MM/YYYY').add(-1, 'days').format('DD/MM/YYYY');
                vm.model.pairingConfig.block = event;
                vm.model.pairingConfig.blockType = CreatePairing.BLOCK_TYPE.EVENT;
                vm.model.pairingConfig.baseBeforeFDPValidation = vm.model.pairingConfig.base;
                CreatePairing.setDataForFDPValidate(vm.model.pairingConfig, updatePairings);
            }

            function addDeadHeading(){
                CreatePairing.removeBlocksFromList(vm.model.pairingConfig, selectedBlockForContextMenu, false, updatePairings);
                var event = CreatePairing.searchPanelEvent();
                var blockInfo = getInforFromBlock(selectedBlockForContextMenu);
                event.selectedEvent = getEventByCode('DHD');
                event.fromDate.value  = blockInfo.startDate;
                event.startLocation.value  = blockInfo.origin;
                event.endLocation.value  = blockInfo.destination;
                event.toDate.value  = blockInfo.endDate;
                event.startTime.value = blockInfo.startTime;
                event.endTime.value = blockInfo.endTime;
                event.eventRelevantFlightLeg.value = blockInfo.flightLegId;
                event.flightNo = selectedBlockForContextMenu.flightNo;
                vm.model.pairingConfig.block = event;
                vm.model.pairingConfig.blockType = CreatePairing.BLOCK_TYPE.EVENT;
                vm.model.pairingConfig.baseBeforeFDPValidation = vm.model.pairingConfig.base;
                CreatePairing.setDataForFDPValidate(vm.model.pairingConfig, updatePairings);
            }

            function addDeadHeadPositioning(){
              CreatePairing.removeBlocksFromList(vm.model.pairingConfig, selectedBlockForContextMenu, false, updatePairings);
              var event = CreatePairing.searchPanelEvent();
              var blockInfo = getInforFromBlock(selectedBlockForContextMenu);
              event.selectedEvent = getEventByCode('DHP');
              event.fromDate.value  = blockInfo.startDate;
              event.startLocation.value  = blockInfo.origin;
              event.endLocation.value  = blockInfo.destination;
              event.toDate.value  = blockInfo.endDate;
              event.startTime.value = blockInfo.startTime;
              event.endTime.value = blockInfo.endTime;
              event.eventRelevantFlightLeg.value = blockInfo.flightLegId;
              event.flightNo = selectedBlockForContextMenu.flightNo;
              vm.model.pairingConfig.block = event;
              vm.model.pairingConfig.blockType = CreatePairing.BLOCK_TYPE.EVENT;
              vm.model.pairingConfig.baseBeforeFDPValidation = vm.model.pairingConfig.base;
              CreatePairing.setDataForFDPValidate(vm.model.pairingConfig, updatePairings);
            }

        function getInforFromBlock(block){
            var startDateStr = '', endDateStr='', type='',
                startTimeStr='', endTimeStr='',origin='', destination='',flightLegId=null;

            if (block.hasOwnProperty('blockDetailList')){
                startDateStr = 'blockStartDateStr';
                endDateStr = 'blockEndDateStr';
                type='blockName';
                startTimeStr='blockStartTimeStr';
                endTimeStr='blockEndTimeStr';
                origin='blockName';
                destination='blockName';
                flightLegId= 'flightLegId';
            }else{
                startDateStr = 'startDateStr';
                endDateStr = 'endDateStr';
                type = 'blockDetailType';
                startTimeStr='startTimeStr';
                endTimeStr='endTimeStr';
                origin='startLocation';
                destination='endLocation';
                flightLegId= 'flightLegId';
            }
            return {
                startDate:block[startDateStr],
                endDate:block[endDateStr],
                blockType:block[type],
                startTime:block[startTimeStr],
                endTime:block[endTimeStr],
                origin:block[origin],
                destination:block[destination],
                flightLegId:block[flightLegId]
            }
        }

        vm.setDefaultValueForDistributionIdentifier = function () {
          if(vm.model.pairingConfig.distributionIdentifier || vm.model.pairingConfig.distributionIdentifier == ""){
            vm.model.pairingConfig.distributionIdentifier = " ";
          }
        }


        function getEventByCode(code){
            var selEvent = null;
            for (var i=0;i<vm.model.events.length;i++){
                selEvent = vm.model.events[i];
                if (selEvent.eventCode===code)
                break;
            }
            return (selEvent.eventCode===code)?selEvent:null;
        }

        function setCopyPairingData(pairingData){
            var tabName = 'createPairing';
            var pairingTabData = StorageServices.getTabData(tabName);
            if(pairingTabData!==null && pairingTabData.hasOwnProperty('editPairingParams')){
                var pairingDataFormTab = pairingTabData.editPairingParams;
                if ( pairingData.patternId === pairingDataFormTab.pairingId ){
                    vm.model.isOpenPairing = true;
                    vm.model.isOpenConfigPairing = true;
                    vm.model.pairingConfig.pairingName  = pairingData.patternName;
                    vm.model.pairingConfig.base = findListObjByValue(vm.model.crewBaseList, pairingData.base, 'airPortCode');
                    vm.model.pairingConfig.distributionIdentifier = getDefaultSelectedIdentifiers(pairingData.distributionIdentifier); //pairingData.distributionIdentifier;
                    vm.model.pairingConfig.isHeavyFlying = pairingData.heavyFlying=='Y'?true:false;
                    vm.model.pairingConfig.isNightFlyNightCredit = pairingData.blockList[0].isOnlyNgtCredit=='Y'?true:false;
                    vm.model.pairingConfig.restInSeat = findListObjByValue(vm.model.restOn, pairingData.restTakenIn, 'itemCode');
                    vm.model.pairingConfig.fromDate = pairingDataFormTab.startDate;
                    vm.model.pairingConfig.toDate = pairingDataFormTab.startDate;
                    vm.model.pairingConfig.durationType = pairingData.durationType!==null?pairingData.durationType.durationTypeDesc:null;
                    vm.model.pairingConfig.departureType = pairingData.departureType!==null?pairingData.departureType.departureTypeDesc:null;
                    vm.model.pairingConfig.dutyPeriod =  CreatePairing.getDutyPeriodByMinutes(pairingData.totalDutyPeriod);
                    vm.model.pairingConfig.patternType = pairingData.patternType;
                    vm.model.pairingConfig.minimumRest = CommonLogicService.getHoursByMinutes(pairingData.minimumRestInMin);
                    vm.model.pairingConfig.throwErrors = false;
                    vm.model.pairingConfig.acmiTypeCode = findListObjByValue(vm.model.masterLists.acmiTypes, pairingData.acmiTypeCode, 'acmiCode');

					if(pairingData.commanderDiscretion === 'Y'){
						vm.model.pairingConfig.isCommandersDiscretion = true;
					}

	                if(pairingData.dispatchFlights === 'Y'){
	                    vm.model.pairingConfig.isDispatchFlight = true;
	                }

	                if(pairingData.wetleaseOperation === 'Y'){
	                    vm.model.pairingConfig.isAcmiOperation = true;
	                }

                    vm.model.pairingConfig.remarks = pairingData.remarks || '';
                    vm.model.pairingConfig.remarksComment = pairingData.remarksComment || '';
                    vm.model.dutyChangeOtherReason = pairingData.remarksComment || '';

                    vm.model.pairingConfig.mandatoryLang = pairingDataFormTab.selectedLanguage;
                    setGenderRequirement( pairingDataFormTab.genderRequirements);
                  // vm.model.pairingConfig.minConnTime = pairingData.minConnTime;
                    CreatePairing.setCrewRequirementsForModifyPairing(pairingDataFormTab.crewRequirements);
                    setCrewRequirement(CreatePairing.getCrewRequirementFormPairing(pairingData.patternCrewList));
                    updateLanguageList(pairingData.patternLanguageList);
                    CreatePairing.setLoadedPairingForSave(pairingData);
                    vm.changeDateTime('toDate');
                    vm.model.isCrewReqValid=true;
                    setDefaultShowEventRest(pairingData.blockList);
                    //vm.model.modeEditableFields = CreatePairing.getDisabledFieldsByMode(vm.model.mode);
                    CreatePairing.setContinueWithViolation(true);
//                    CreatePairing.throwErrors(false);
                    CreatePairing.setDataForFDPValidate(vm.model.pairingConfig, updatePairings);
                    vm.model.fdpValidFlag = true;
                    vm.model.pairingConfig.isEditPairing = true;
                    vm.model.requestOrigin = pairingDataFormTab.requestOrigin;
                    vm.model.relatedPatterns = pairingData.relatedPatternInfoList;
                    vm.model.pairingConfig.relatedPatterns = pairingData.relatedPatterns;
                    vm.model.pairingConfig.selectedRelatedPatterns = getDefaultSelectedPattern(pairingData)

                    vm.model.pairingConfig.throwErrors = true;

                    // save copy pairing audit
                  if(pairingDataFormTab.editPairingMode==='copy'){
                      saveCopyPairingAudit(pairingData.patternId);
                  }
                }
            }
        }

        function getDefaultSelectedIdentifiers(selectedDistributionIdentifier) {
          var selectedIdentifiers = [];
          if (!!selectedDistributionIdentifier && selectedDistributionIdentifier !== ''){
            var identifiers = selectedDistributionIdentifier.split(',');
            angular.forEach(identifiers, function(i) {
              var identifierDTO = {
                valueFieldName: i,
                labelFieldName: i
              };
              selectedIdentifiers.push(identifierDTO);
            });

          }
          return selectedIdentifiers;
        }


        function getDefaultSelectedPattern(pairingData) {
          var patternId = pairingData.patternId;
          var selectedRelatedPatterns = [];
          angular.forEach(pairingData.relatedPatterns, function(pattern) {

            if(angular.equals(pattern.patternId,patternId)){
              selectedRelatedPatterns.push(pattern);
            }
          });

          return selectedRelatedPatterns;
        }

        function saveCopyPairingAudit(patternId) {
          var copyPairingAuditReq = {};
          copyPairingAuditReq.patternId = patternId;
          copyPairingAuditReq.action = 'COPY_PATTERN';
          CreatePairing.savePairingAudit(copyPairingAuditReq,
            function (searchResults) {
            },
            function (error) {
            });
        }

        function setDefaultShowEventRest(blockList) {
          angular.forEach(blockList, function(block){
            vm.model.pairingConfig.fdpExtensionFlags.push({
              legIds: getFlightLegIdsFromBlock(block),
              extension: block.extension,
              discretion: block.discretion,
              splitDutyExtension: block.splitDutyExtension
            });

            angular.forEach(block.blockDetailList, function(blockDetail){
              if(blockDetail.blockDetailType === 'EVENT' && blockDetail.eventCode === 'RST') {
                vm.model.restPairing = true;
                CreatePairing.setShowEventRest(vm.model.restPairing, updatePairings);
              }
            });
          });
        }

        function findListObjByValue(list, value, valueKey){
            var send=null;
            for(var i =0;i<list.length;i++){
                if (list[i][valueKey] === value){
                    send = list[i]
                    break;
                }
            }
            return send;
        }

        function getFlightLegIdsFromBlock(block){
          var flightLegIds = [];
          angular.forEach(block.blockDetailList, function(blockDetail){
            if(blockDetail.blockDetailType === 'FLIGHT'){
              flightLegIds.push(blockDetail.flightLegId);
            }
          });
          return flightLegIds;
        }

        (function init() {

            CommonMasterData.getCrewTypeList(
                function (response) {
                    $timeout(function () {
                        vm.model.crewTypes = response;
                        vm.model.crewTypeCodes = response;
                        if(vm.model.pairingId === undefined || vm.model.pairingId===null){
                        	CreatePairing.setPairingCrewRequirements(response);
                        }
                        vm.model.isOpenConfigPairing = true;
                    }, 100)
                },
                function (error) {
                    MessageService.error(MessageService.MESSAGES.COMMON.SYSTEM_ERROR);
                }
            );
            CommonMasterData.getCrewBaseList(
                function (crewBase) {
                    vm.model.crewBaseList = crewBase;
                }, function (error) {
                    //TODO handel the error
                    MessageService.error(MessageService.MESSAGES.COMMON.SYSTEM_ERROR);
                }
            );
            CommonMasterData.getAirportList(
                function (airportList) {
                    vm.model.airportList = airportList;
                },
                function (error) {
                    MessageService.error(error);
                }
            );

          vm.model.numberOfDays = [
            {days: 1, description: '1 Day'},
            {days: 2, description: '2 Days'},
            {days: 3, description: '3 Days'},
            {days: 4, description: '4 Days'},
            {days: 5, description: '5 Days'},
            {days: 6, description: '6 Days'},
            {days: 7, description: '7 Days'}
          ];

          vm.toggleBlockOptions = function(event) {
            $('.block-options-wrapper.visible').removeClass('visible');
            event.currentTarget.classList.toggle('visible')
          }

          vm.onChangeFlag = function() {
            CreatePairing.validateFdpAfterAddingFlags(vm.model.pairingConfig.fdpExtensionFlags, updatePairings);
          }

          CommonMasterData.getDropDownList(1, 'ALL', function(reasons) {
              vm.model.dutyChangeReasons = reasons;
          }, function() {
              console.log('Remarks reasons load error');
          });

          $scope.$watch(function() {
              return vm.model.dutyChangeReasons !== null && !!vm.model.pairingConfig.remarks;
          }, function(bothReady) {
              if (bothReady) {
                  preselectRemarksReason(vm.model.pairingConfig.remarks);
              }
          });

          function preselectRemarksReason(remarksValue) {
              var matched = vm.model.dutyChangeReasons.filter(function(r) {
                  return r.dropdownValue === remarksValue;
              })[0];
              if (matched) {
                  vm.model.dutyChangeReason = matched;
              } else {
                  var otherOption = vm.model.dutyChangeReasons.filter(function(r) {
                      return r.dropdownValue === 'Other';
                  })[0];
                  vm.model.dutyChangeReason = otherOption || null;
              }
              vm.model.dutyChangeOtherReason = vm.model.pairingConfig.remarksComment || '';
          }

          vm.onRemarksReasonChange = function() {
              vm.model.pairingConfig.remarks = vm.model.dutyChangeReason ? vm.model.dutyChangeReason.dropdownValue : '';
              vm.model.pairingConfig.remarksComment = vm.model.dutyChangeOtherReason || '';
          };

          vm.onRemarksOtherTextChange = function() {
              vm.model.pairingConfig.remarksComment = vm.model.dutyChangeOtherReason || '';
              if (vm.model.dutyChangeOtherReason) {
                  vm.model.remarksCommentValidationError = false;
              }
          };

          vm.getFdpFlagIndex = function(block) {
            var index = -1;
            const legIdsFromBlock = getFlightLegIdsFromBlock(block);
            vm.model.pairingConfig.fdpExtensionFlags.forEach(function (flag, i) {
              if(compareFlightLegsIdList(flag.legIds, legIdsFromBlock)) {
                index = i;
              }
            });

            return index;
          }

          function compareFlightLegsIdList(list1, list2) {
            var res = false;
            list1.forEach(function(legId){
              if(list2.includes(legId)) {
                res = true;
              }
            });

            return res;
          }

            CommonMasterData.loadAppParamList(defaultBase,
              function (response) {
               var defaultBaseAirport =  _.find(vm.model.crewBaseList,{"airPortCode":response.appParamGroupMap.GENERAL[0].paramValue});
                // vm.model.pairingConfig.base = defaultBaseAirport;
                vm.model.defaultBase = defaultBaseAirport;
              },
              function (error) {
                MessageService.error(error);
              }
            );

            CommonMasterData.getIsNightForNightCreditEnable(function(response) {
              vm.model.enableNightForNightCredit = response;
            }, function(error) {
              MessageService.error(error);
            });

            CommonMasterData.getACMITypesList(function (acmiTypes) {
                                vm.model.masterLists.acmiTypes = acmiTypes;
                            }, function (error) {

            });

            CommonMasterData.getACModelCrewRequirement(function(response) {
              vm.model.acModelCrewRequirement = _.groupBy(response, 'modelNumber');
            }, function(error) {
              MessageService.error(error);
            });

            var requestEventData = CreatePairing.getPairingSearchCriteria();
            CommonMasterData.searchEvents(requestEventData,
                function (eventResults) {
                    vm.model.events = eventResults;
                },
                function (error) {
                    MessageService.error(error);
                }
            );

            CommonMasterData.getAircraftModels(function (airCraftList) {
                vm.model.airCraftTypes = airCraftList;

                ToolBarService.setButtonConfigsToView(vm.view, viewButtonConfigs);
                CreatePairing.initService();
                if(vm.model.pairingId!==null && vm.model.pairingId!==undefined && vm.model.pairingId!==""){
                    CreatePairing.loadPairingByID(vm.model.pairingId, vm.model.mode,
                    function(result){
                      vm.model.pairingConfig.defaultCrewReq =  vm.model.acModelCrewRequirement[result.aircraftModelNum1];
                        setCopyPairingData(result);
                        vm.model.pairingStartDate = result.blockList[0].blockStartDateStr;
                        initialTrainingPanelLoad(vm.model.pairingStartDate);
                        initialFlightPanelLoad(vm.model.pairingStartDate);

                    },
                    function(error){

                    });
                }
            }, function (error) {

            });

            CommonMasterData.getTrainingCategories(function (categories) {
              vm.model.trainingCategoryList = categories;
            });

            CommonMasterData.getTrainingLocationList(function (locations) {
              vm.model.trainingLocationsList = locations;
            });

            var searchRequest = ApplicationParametersService.getAppParamSearchRequest([]);
            CommonMasterData.loadAppParamList(searchRequest,
	            function(paramList) {
	            	var appParam = paramList.appParamGroupMap.PATTERN;
	            	 angular.forEach(appParam, function(patternParam){
	                     if (patternParam.paramKey === 'VIEW_BASE_LIST_IN_SBY_PATTERN'){
	                    	  vm.model.appParam.pattern.baseListInSby = patternParam.paramValue==='Y'?true:false;
	                     }
                       if (patternParam.paramKey === 'ENABLE_MANUAL_SPLIT_DUTY_EXTENTION'){
                         vm.model.appParam.pattern.manualSplitDutyExtention = patternParam.paramValue==='Y'?true:false;
                       }
                       if (patternParam.paramKey === 'ENABLE_PAIRING_REMARKS'){
                         vm.model.appParam.pattern.pairingRemarksCarrierList = patternParam.paramValue;
                       }
	                 });
	                 var generalParam = paramList.appParamGroupMap.GENERAL;
	                 angular.forEach(generalParam, function(param){
	                     if (param.paramKey === 'CARRIER_CODE'){
	                         vm.model.appParam.carrierCode = param.paramValue;
	                     }
	                 });
	                 computePairingRemarksEnabled();
              },
              function(error) {
                 MessageService.error(error);
            });

            CommonMasterData.searchCarriers(
                    function (response) {
                    	for(var index in response.hubCodes) {
                    		vm.model.carriers.push({"code":response.hubCodes[index],"name":response.hubCodes[index]});
                    	}
                    	vm.model.defaultCarrier = response.clientCode;
                    },
                    function (error) {
                      MessageService.error(error);
                    }
            );

        }());


      ConfigDistributionService.searchActiveIdentifiers(
        function(identifiers){
          var identifierObject = [];
          angular.forEach(identifiers ,function(identifier){
            var updateExpiryCrewDTO = {
              valueFieldName: identifier,
              labelFieldName: identifier
            };
            identifierObject.push(updateExpiryCrewDTO);
          });
          vm.model.masterLists.identifiers=identifierObject;
        },
        function(error){
          MessageService.error(error);
        }
      );

    }

    $(window).resize(function(){
    	var height=($("header").height() + $(".tabbed-view-container").height())+"px";
    	$(".create-pattern-view .canvas").css("top", height);
    });

    $(document).click(function(event) {
      if (!$(event.target).closest('.block-options-wrapper').length) {
        $('.block-options-wrapper.visible').removeClass('visible');
      }
    });
}());
